import React from 'react';
import _ from 'lodash';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

class Cat extends PositionedGoodyHOC {
	// 2
	render() {
		const style = {
			st146: {
				fill: 'none',
			},
			st13: {
				fill: '#F2CC7B',
			},
			st2: {
				fill: '#FFFFFF',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="62.118824" cy="20.3631306" />
				<path style={style.st13} d="M31.2946053,41.7856255c-1.3769531,0-2.7675781-0.105957-4.1591797-0.3208008
					c-8.3378906-1.2890625-15.2148447-7.5307617-19.8867188-18.0507812C3.7985108,15.6445112,2.7545655,8.355937,2.7125733,8.0492964
					l2.9707034-0.4145503c0.0400391,0.2807617,4.1445308,28.1191406,21.9111328,30.8652344
					c6.1152344,0.9458008,12.2099609-0.4750977,16.7167969-3.8974609c3.4501953-2.6186523,5.6015625-6.1708984,6.0595703-10.0019531
					l0.0361328-0.2104492c0.6328125-5.3203125,5.5507812-9.1767588,11.7119141-9.1767588
					c6.1581993,0,11.0732384,3.8515635,11.7109337,9.1665049l0.0234375,0.1279297
					c0.4716797,3.9238281,2.6230469,7.4760742,6.0732422,10.0947266c4.5078125,3.4213867,10.5986328,4.8417969,16.7167969,3.8974609
					c17.7910156-2.75,21.8720703-30.5839844,21.9111328-30.8647461l2.9707031,0.414062
					c-0.0419922,0.3066406-1.0859375,7.5952148-4.5361328,15.364747
					c-4.671875,10.5200195-11.5488281,16.7617188-19.8867188,18.0507812
					c-6.9189453,1.0688477-13.8369141-0.5610352-18.9902344-4.4726562
					c-4.1035156-3.1152344-6.6689453-7.3896484-7.2236328-12.0361328l-0.0332031-0.1831055
					c-0.4355469-3.8007812-4.109375-6.5595703-8.7363243-6.5595703s-8.3007812,2.7587891-8.7363281,6.5595703l-0.046875,0.2758789
					c-0.5410156,4.5537109-3.1064453,8.828125-7.2099609,11.9433594
					C42.009449,40.1166801,36.7643318,41.7851372,31.2946053,41.7856255z"/>
				<path style={style.st2} d="M51.7975349,24.0424614c-1.9511719,0-3.6591797-1.4287109-3.9521484-3.4160156
					c-0.9667969-6.5473642-6.5283203-11.2070322-14.515625-12.1611338
					C21.8981209,7.1010547,5.4381595,11.6489058,5.2750735,11.6948042c-2.1308596,0.59375-4.3349609-0.6479492-4.9296875-2.7758789
					c-0.5947266-2.1274409,0.6484375-4.3344722,2.7753906-4.9291992c0.7363281-0.2055664,18.1611328-5.0195312,31.1582031-3.4677734
					c11.5537109,1.3798828,19.9863281,8.8125,21.4804688,18.9355469c0.3222656,2.1855469-1.1875,4.21875-3.3730469,4.5415039
					C52.1891365,24.0283012,51.9918709,24.0424614,51.7975349,24.0424614z"/>
				<path style={style.st13} d="M4.820972,9.0214643c-0.6835938,0-1.3007815-0.4692383-1.4609377-1.1630855
					C3.1744874,7.0507617,3.677417,6.2455859,4.4850345,6.0595508l2.1669922-0.5
					c0.8115234-0.1894531,1.6123042,0.3168945,1.7988276,1.1240234c0.1855469,0.8076172-0.3173828,1.6127925-1.1249995,1.7988276
					l-2.1669922,0.5C5.0455813,9.008769,4.9323001,9.0214643,4.820972,9.0214643z"/>
				<path style={style.st2} d="M72.2028046,24.0424614c-0.1943359,0-0.3916016-0.0141602-0.5898438-0.043457
					c-2.1855469-0.3227539-3.6953125-2.3564453-3.3720703-4.5419922C69.7369843,9.3344526,78.1686249,1.9018358,89.7223358,0.5219529
					c12.9892578-1.550293,30.4199219,3.2617188,31.1572266,3.4677734c2.1269531,0.5947268,3.3691406,2.8007815,2.7753906,4.9277344
					c-0.5947266,2.1269531-2.796875,3.3720703-4.9277344,2.7773438c-0.1660156-0.0458984-16.6523438-4.5922847-28.0556641-3.2294922
					c-7.9863281,0.9541016-13.5488281,5.6137695-14.5166016,12.161622
					C75.8610077,22.6137505,74.1529999,24.0424614,72.2028046,24.0424614z"/>
				<path style={style.st13} d="M119.1803436,9.0214643c-0.1113281,0-0.2246094-0.0126953-0.3378906-0.0390625l-2.1669922-0.5
					c-0.8076172-0.1860352-1.3105469-0.9912105-1.125-1.7988276c0.1865234-0.8061523,0.9912109-1.3134766,1.7988281-1.1240234
					l2.1669922,0.5c0.8076172,0.1860352,1.3105469,0.9912109,1.125,1.7988281
					C120.4811249,8.5517378,119.8639374,9.0214643,119.1803436,9.0214643z"/>
			</g>
		);
	}
}

class Tortoise extends PositionedGoodyHOC {
	// 2
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="32.8187103" cy="10.6788435" />
				<path fill="#F2CC7B" d="M16.4818745,22.0327663c-0.7297859,0-1.4668169-0.0561581-2.2043657-0.1700249
					c-4.4190826-0.6832027-8.0638676-3.9913044-10.5399609-9.5669146C1.9089439,8.1779757,1.3556529,4.3150315,1.333397,4.1525121
					l1.5744725-0.219712c0.0212207,0.1488035,2.1966016,14.9031448,11.6129007,16.3585739
					c3.2410746,0.5012741,6.4712801-0.2518024,8.8599024-2.0656548c1.8286037-1.387886,2.9688282-3.2705755,3.2115726-5.3010349
					l0.0191498-0.1115379c0.3353901-2.819766,2.9419136-4.8636818,6.2073154-4.8636818
					c3.2638474,0,5.8688164,2.0413284,6.2067947,4.8582468l0.0124245,0.0678034
					c0.2499886,2.0796289,1.390213,3.9623184,3.2188187,5.3502045c2.3891373,1.8133354,5.6172752,2.5661526,8.8599014,2.0656548
					C60.545887,18.8338737,62.708847,4.0818624,62.7295494,3.9330587l1.5744743,0.2194533
					c-0.0222549,0.1625195-0.5755501,4.0254636-2.4041519,8.1433144c-2.4760933,5.5756102-6.1208801,8.8837118-10.5399628,9.5669146
					c-3.667038,0.5664883-7.3335609-0.297348-10.0648232-2.3705082c-2.1748619-1.6510735-3.5345421-3.9165134-3.8285255-6.3791504
					l-0.0175972-0.0970459c-0.2308388-2.0144138-2.1779671-3.476572-4.6302528-3.476572s-4.3994141,1.4621582-4.6302547,3.476572
					l-0.0248432,0.1462164c-0.2867393,2.4134665-1.6464157,4.6789064-3.8212795,6.3299799
					C22.1607399,21.1482239,19.3808289,22.0325069,16.4818745,22.0327663z"/>
				<path fill="#FFFFFF" d="M27.3484268,12.6288891c-1.0341225,0-1.9393654-0.7572174-2.0946388-1.8104887
					c-0.5124035-3.4701023-3.4600105-5.9397264-7.6932812-6.4454002C11.5017366,3.6499436,2.7779574,6.0603046,2.6915221,6.084631
					C1.5621666,6.3993187,0.3939927,5.7412181,0.0787876,4.6134152c-0.3152051-1.1275439,0.3436719-2.2972705,1.470957-2.6124756
					c0.3902539-0.1089503,9.6254005-2.6603515,16.5138474-1.83792c6.1234665,0.7313379,10.5927525,4.6706252,11.3846474,10.0358391
					c0.1708012,1.1583405-0.6293755,2.2359381-1.787714,2.4069977C27.555975,12.6213837,27.4514236,12.6288891,27.3484268,12.6288891
					z"/>
				<path fill="#F2CC7B" d="M2.4508481,4.6677608c-0.3623047,0-0.689414-0.2486963-0.7742968-0.6164355
					C1.5782114,3.6232882,1.8447642,3.1965451,2.2728014,3.0979464l1.1485057-0.2649999
					c0.4301076-0.1004102,0.8545218,0.167954,0.9533792,0.5957322c0.0983396,0.4280372-0.1682129,0.8547804-0.5962501,0.9533789
					L2.6299303,4.6470575C2.5698912,4.6610322,2.5098522,4.6677608,2.4508481,4.6677608z"/>
				<path fill="#FFFFFF" d="M38.1632195,12.6288891c-0.1029968,0-0.2075462-0.0075054-0.3126144-0.0230322
					c-1.1583405-0.1710596-1.9585152-1.2489166-1.7871971-2.4072561c0.7929268-5.3649559,5.2616997-9.3042431,11.3851662-10.0355806
					c6.884304-0.8216553,16.1225586,1.728711,16.5133286,1.83792c1.127285,0.3152051,1.7856483,1.4844141,1.4709587,2.6116993
					c-0.3152084,1.127285-1.4823456,1.7871971-2.611702,1.471992c-0.087986-0.0243263-8.8257408-2.4339111-14.8694992-1.7116308
					c-4.2327538,0.5056739-7.1808815,2.9752979-7.6938019,6.4456596
					C40.1020699,11.8716717,39.1968231,12.6288891,38.1632195,12.6288891z"/>
				<path fill="#F2CC7B" d="M63.0613174,4.6677608c-0.0590057,0-0.1190453-0.0067286-0.179081-0.0207033l-1.1485062-0.2649999
					c-0.4280396-0.0985985-0.6945915-0.5253417-0.5962524-0.9533789c0.0988579-0.4272606,0.5253448-0.6961424,0.9533806-0.5957322
					l1.1485062,0.2649999c0.4280357,0.0985987,0.6945877,0.5253417,0.5962486,0.9533789
					C63.7507324,4.4188056,63.4236221,4.6677608,63.0613174,4.6677608z"/>
			</g>
		);
	}
}

class Chicken extends PositionedGoodyHOC {
	// 2
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} fill="none" cx="43.34547" cy="14.10413" />
				<path fill="#F2CC7B" d="M21.76851,29.09988c-0.96387,0-1.93731-0.07417-2.91143-0.22456
					c-5.83652-0.90234-10.65039-5.27153-13.9207-12.63555C2.52125,10.8011,1.79048,5.6991,1.76109,5.48445l2.07949-0.29019
					c0.02803,0.19653,2.90117,19.6834,15.33779,21.60567c4.28066,0.66206,8.54697-0.33257,11.70176-2.72822
					c2.41514-1.83306,3.92109-4.31963,4.2417-7.00137l0.02529-0.14732c0.44297-3.72422,3.88555-6.42373,8.19834-6.42373
					c4.31074,0,7.75127,2.69609,8.19765,6.41655l0.01641,0.08955c0.33017,2.74668,1.83613,5.23325,4.25127,7.06631
					c3.15547,2.39497,7.41904,3.38926,11.70176,2.72822c12.4537-1.925,15.31045-21.40879,15.33779-21.60532l2.07949,0.28984
					c-0.0294,0.21465-0.76015,5.31665-3.17529,10.75532c-3.27031,7.36401-8.08418,11.7332-13.9207,12.63555
					c-4.84327,0.74819-9.68584-0.39272-13.29317-3.13086c-2.87246-2.18066-4.66826-5.17275-5.05654-8.42529l-0.02324-0.12817
					c-0.30488-2.66055-2.87656-4.5917-6.11543-4.5917c-3.23887,0-5.81055,1.93115-6.11543,4.5917l-0.03281,0.19312
					c-0.37871,3.1876-2.17451,6.17969-5.04697,8.36035C29.2689,27.93162,25.59732,29.09954,21.76851,29.09988z"/>
				<path fill="#FFFFFF" d="M36.12056,16.67966c-1.36582,0-2.56143-1.0001-2.76651-2.39121
					C32.6773,9.7053,28.78424,6.44353,23.19312,5.77566C15.19097,4.82068,3.669,8.00418,3.55484,8.03631
					c-1.4916,0.41562-3.03447-0.45356-3.45078-1.94312c-0.41631-1.48921,0.45391-3.03413,1.94277-3.45044
					c0.51543-0.1439,12.71279-3.51367,21.81074-2.42744C31.94517,1.18123,37.848,6.38406,38.8939,13.47019
					c0.22559,1.52988-0.83125,2.95312-2.36113,3.17905C36.39468,16.66975,36.2566,16.67966,36.12056,16.67966z"/>
				<path fill="#F2CC7B" d="M3.23697,6.16497c-0.47852,0-0.91055-0.32847-1.02266-0.81416
					c-0.12988-0.56533,0.22217-1.12896,0.7875-1.25918l1.51689-0.35c0.56807-0.13262,1.12861,0.22183,1.25918,0.78682
					c0.12988,0.56533-0.22217,1.12895-0.7875,1.25918l-1.51689,0.35C3.3942,6.15608,3.3149,6.16497,3.23697,6.16497z"/>
				<path fill="#FFFFFF" d="M50.40425,16.67966c-0.13604,0-0.27412-0.00991-0.41289-0.03042
					c-1.52988-0.22593-2.58672-1.64951-2.36045-3.17939c1.04727-7.08579,6.94942-12.28862,15.03701-13.25454
					c9.09248-1.08521,21.29394,2.2832,21.81005,2.42744c1.48887,0.41631,2.3584,1.96055,1.94278,3.44941
					c-0.41631,1.48887-1.95782,2.36045-3.44942,1.94414c-0.11621-0.03213-11.65664-3.2146-19.63897-2.26064
					C57.74195,6.44353,53.8482,9.7053,53.17076,14.2888C52.965,15.67957,51.76939,16.67966,50.40425,16.67966z"/>
				<path fill="#F2CC7B" d="M83.28853,6.16497c-0.07793,0-0.15723-0.00889-0.23652-0.02734l-1.5169-0.35
					c-0.56533-0.13022-0.91738-0.69385-0.7875-1.25918c0.13057-0.56431,0.69385-0.91943,1.25918-0.78682l1.5169,0.35
					c0.56533,0.13022,0.91738,0.69385,0.7875,1.25918C84.19908,5.83616,83.76704,6.16497,83.28853,6.16497z"/>
			</g>
		);
	}
}


function CatEye(props) {
	const glasses = {
		Cat,
		Tortoise,
		Chicken,
	};

	const ThisCatEye = glasses[props.petType.name] || Cat;

	if (_.isUndefined(ThisCatEye)) {
		return null;
	}

	return <ThisCatEye {...props} />;
}

export default CatEye;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Glasses/CatEye.js